import { render, staticRenderFns } from "./CardApplications.vue?vue&type=template&id=520ad3fe&scoped=true&"
import script from "./CardApplications.vue?vue&type=script&lang=js&"
export * from "./CardApplications.vue?vue&type=script&lang=js&"
import style0 from "./CardApplications.vue?vue&type=style&index=0&id=520ad3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ad3fe",
  null
  
)

/* custom blocks */
import block0 from "./CardApplications.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports